module.exports = __webpack_public_path__ + "img/read_arrow.33ca01ce.svg";